import { createSlice } from '@reduxjs/toolkit';
import { ascSort } from 'utils/array';

import type { StrategyStoreType } from './types/strategies';
import type { RootState } from './configureStore';

const initialState: StrategyStoreType = {
  clients: {
    assigned: {
      start: [],
      current: [],
    },
    notAssigned: {
      start: [],
      current: [],
      filter: null,
    },
    searchOptions: [],
  },
  selected: 'Todos',
  representative: 'Todos',
};

export const slice = createSlice({
  name: 'strategies',
  initialState,
  reducers: {
    selectedStrategy: (strategies, action) => {
      strategies.selected = action.payload;
    },

    selectedRepresentative: (strategies, action) => {
      strategies.representative = action.payload;
    },

    assignedClients: (strategies, action) => {
      const clients = ascSort(action.payload.clients, 'displayName');

      if (action.payload.start) strategies.clients.assigned.start = clients;
      strategies.clients.assigned.current = clients;
    },

    notAssignedClients: (strategies, action) => {
      const clients = ascSort(action.payload.clients, 'displayName');

      if (action.payload.start) {
        strategies.clients.notAssigned.start = clients;
      }

      strategies.clients.notAssigned.current = clients;
    },

    filteredClients: (strategies, action) => {
      const { notAssigned } = strategies.clients;

      notAssigned.filter = action.payload;
    },

    setSearchOptions: (strategies, action) => {
      const clients = ascSort([...action.payload], 'displayName');

      strategies.clients.searchOptions = clients;
    },

    resetFilter: (strategies) => {
      const { notAssigned } = strategies.clients;
      notAssigned.filter = null;
    },
  },
});

export const {
  assignedClients,
  notAssignedClients,
  selectedStrategy,
  selectedRepresentative,
  resetFilter,
  filteredClients,
  setSearchOptions,
} = slice.actions;
export default slice.reducer;

// Selectors
export const getStrategyClients = (state: RootState) =>
  state.entities.strategies.clients;
export const getSelectedStrategy = (state: RootState) =>
  state.entities.strategies.selected;
export const getSelectedRepresentative = (state: RootState) =>
  state.entities.strategies.representative;
